const AccessDeniedPage = () => (
  <div className='flex min-h-[50vh] items-center justify-center'>
    <div className='text-center text-jaguar'>
      <h1 className='text-2xl font-semibold'>Access Denied</h1>
      <p className='mt-2 text-sm'>
        You do not have permission to view this page.
      </p>
    </div>
  </div>
);

export default AccessDeniedPage;
